const generateReducedDeductibleKey = (reducedDeductibleOption) =>
  !reducedDeductibleOption
    ? ''
    : `${reducedDeductibleOption?.deductible_amount}-${reducedDeductibleOption?.rate}`;

export default generateReducedDeductibleKey;
